module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門1_7_2.a37a3c90.png";